import EventHandler from '@pixelunion/events';
import Disclosure from '@pixelunion/shopify-cross-border';

import Sidebar from '../components/Sidebar';
import NavMobileFilters from '../components/NavMobileFilters';
import ProductThumbnail from '../components/ProductThumbnail';

export default class CollectionPage {
  constructor(section) {
    this.el = section.el;
    this.settings = section.data;

    this.events = new EventHandler();

    this.collectionFilters = this.el.querySelector('[data-collection-filters]');
    this.sortByDisclosureEl = this.el.querySelector('[data-sort-by-disclosure]');
    this.sidebarEl = this.el.querySelector('[data-sidebar-top]');
    this.sidebarBottomEl = this.el.querySelector('[data-sidebar-bottom]');
    this.mobileFiltersMenu = this.el.querySelector('[data-mobile-filters]');
    this.productList = this.el.querySelectorAll('[data-product-thumbnail]');

    // We need to initialize 2 sidebars because on desktop the normal sidebar is used,
    // and on mobile, if a bottom sidebar is used, we have it there.
    // The sidebar class determines if the sidebar exists.
    this.sidebar = new Sidebar(this.sidebarEl);
    this.sidebarBottom = new Sidebar(this.sidebarBottomEl);

    this.mobileFilters = new NavMobileFilters({
      controls: this.collectionFilters,
      mobileNav: this.mobileFiltersMenu,
    });

    this.productThumbnails = [];

    const thumbnailSettings = {
      showSecondaryMediaOnHover: this.settings.show_secondary_media,
    };

    this.productList.forEach(product => {
      this.productThumbnails.push(new ProductThumbnail(product, thumbnailSettings));
    });

    if (this.sidebarEl) {
      // This is added to set the top margin of the sidebar so that it is aligned with the content.
      this.sidebarEl.style.setProperty('--filter-bar-height', `${this.collectionFilters.offsetHeight}px`);
    }

    if (this.sortByDisclosureEl) {
      this.sortByDisclosure = new Disclosure(this.sortByDisclosureEl);
    }
  }

  onSectionUnload() {
    this.events.unregisterAll();
    this.sidebar.unload();
    this.sidebarBottom.unload();
    this.mobileFilters.unload();

    this.productThumbnails.forEach(product => product.unload());

    if (this.sortByDisclosure) {
      this.sortByDisclosure.unload();
    }
  }
}
